module.exports = __webpack_public_path__ + "media/images/flags/64/Palestine-c1b582ac5da13ff7c0fa4bc165d1b417.png";